import React from 'react'
import { Route, ArrowRight, ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'

const OurCommitment = () => {
  return (
    <section className='relative isolate overflow-hidden bg-[#fffdf8] px-2 py-4 sm:px-4 sm:py-5 lg:px-6 lg:py-5'>
      {/* Background glow */}
      <div className='pointer-events-none absolute -left-24 top-0 h-56 w-56 rounded-full bg-[#ffe331]/15 blur-[90px]' />
      <div className='pointer-events-none absolute -right-16 bottom-0 h-64 w-64 rounded-full bg-[#e9ecff]/70 blur-[100px]' />

      <div className='relative mx-auto w-full max-w-[1320px]'>
        {/* CTA Banner */}
        <div className='group relative isolate overflow-hidden rounded-[22px] border border-white/10 bg-[#211f57] shadow-[0_20px_55px_rgba(33,31,87,0.17)] transition-shadow duration-500 hover:shadow-[0_25px_65px_rgba(33,31,87,0.23)] sm:rounded-[28px]'>
          {/* Decorative illustration */}
          <div
            aria-hidden='true'
            className='pointer-events-none absolute -right-8 -top-16 -z-10 rotate-[-12deg] text-white/[0.055] transition-transform duration-700 group-hover:rotate-0 group-hover:scale-105'
          >
            <Route size={260} strokeWidth={0.7} />
          </div>

          {/* Ambient glow */}
          <div
            aria-hidden='true'
            className='pointer-events-none absolute -bottom-24 right-[25%] -z-10 h-52 w-52 rounded-full bg-[#ffe331]/10 blur-[70px]'
          />

          {/* Top accent */}
          <div className='absolute left-0 top-0 h-[3px] w-full bg-gradient-to-r from-[#ffe331] via-[#f32643] to-transparent' />

          <div className='relative flex flex-col items-start justify-between gap-5 px-5 py-7 sm:gap-7 sm:px-8 sm:py-9 md:flex-row md:items-center md:gap-8 lg:px-8 lg:py-8'>
            {/* Left content */}
            <div className='w-full max-w-2xl'>
              <h2 className='text-[23px] font-extrabold leading-tight tracking-tight text-white sm:text-2xl md:whitespace-nowrap lg:text-[38px]'>
                Every Mile.
                <span className='text-[#ffe331]'> Every Shipment.</span>
                <span> Every Promise.</span>
              </h2>

              <p className='mt-3 text-xs leading-6 text-white/65 sm:text-sm md:whitespace-nowrap'>
                Discover how our people, network, and purpose come together to
                move your business forward with confidence.
              </p>

              {/* Trust detail */}
              <div className='mt-4 flex items-start gap-2 text-[11px] font-medium leading-5 text-white/55 sm:items-center sm:text-xs'>
                <ShieldCheck
                  size={16}
                  className='mt-0.5 shrink-0 text-[#ffe331] sm:mt-0'
                />

                <span>
                  Reliable logistics. Stronger partnerships. Better journeys.
                </span>
              </div>
            </div>

            {/* Right CTA */}
            <div className='flex w-full shrink-0 flex-col gap-3 sm:w-auto md:items-start'>
              <Link
                to='/about-us'
                className='group/btn inline-flex min-h-12 w-full items-center justify-center gap-3 rounded-xl bg-[#ffe331] px-6 py-3.5 text-sm font-extrabold text-[#211f57] shadow-[0_8px_24px_rgba(255,227,49,0.12)] transition-all duration-300 hover:-translate-y-1 hover:bg-white hover:shadow-[0_12px_28px_rgba(0,0,0,0.16)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#211f57] sm:min-w-[200px] sm:text-xs'
              >
                Discover Our Story
                <ArrowRight
                  size={17}
                  className='transition-transform duration-300 group-hover/btn:translate-x-1'
                />
              </Link>
            </div>
          </div>

          {/* Bottom accent */}
          <div className='absolute bottom-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent' />
        </div>
      </div>
    </section>
  )
}

export default OurCommitment
